__turbopack_context__.v({
  "Streamdown": "VCISYG_Streamdown",
  "compact": "VCISYG_compact",
  "dark": "VCISYG_dark",
  "prose": "VCISYG_prose",
  "prose-sm": "VCISYG_prose-sm",
  "thinking-shimmer": "VCISYG_thinking-shimmer",
  "thinkingShimmer": "VCISYG_thinkingShimmer",
});
